import React from 'react';

interface FourDotsProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  animate?: boolean;
  className?: string;
  opacity?: number;
}

export function FourDots({ size = 'md', animate = false, className = '', opacity = 1 }: FourDotsProps) {
  const sizeMap = {
    xs: { dot: 'w-2 h-2', gap: 'gap-1' },
    sm: { dot: 'w-3 h-3', gap: 'gap-1.5' },
    md: { dot: 'w-6 h-6', gap: 'gap-2' },
    lg: { dot: 'w-12 h-12', gap: 'gap-3' },
    xl: { dot: 'w-20 h-20', gap: 'gap-4' },
    '2xl': { dot: 'w-32 h-32', gap: 'gap-6' }
  };

  const { dot, gap } = sizeMap[size];

  return (
    <div className={`inline-grid grid-cols-2 ${gap} ${className}`} style={{ opacity }}>
      <div 
        className={`${dot} bg-gradient-to-br from-orange-500 to-orange-600 rounded-full ${animate ? 'animate-pulse' : ''}`} 
        style={animate ? { animationDelay: '0ms', animationDuration: '2s' } : undefined}
      />
      <div 
        className={`${dot} bg-gradient-to-br from-pink-500 to-pink-600 rounded-full ${animate ? 'animate-pulse' : ''}`}
        style={animate ? { animationDelay: '200ms', animationDuration: '2s' } : undefined}
      />
      <div 
        className={`${dot} bg-gradient-to-br from-red-400 to-red-500 rounded-full ${animate ? 'animate-pulse' : ''}`}
        style={animate ? { animationDelay: '400ms', animationDuration: '2s' } : undefined}
      />
      <div 
        className={`${dot} bg-gradient-to-br from-orange-400 to-yellow-500 rounded-full ${animate ? 'animate-pulse' : ''}`}
        style={animate ? { animationDelay: '600ms', animationDuration: '2s' } : undefined}
      />
    </div>
  );
}


